import { UNREAD_MESSAGE_UPDATE, UNREAD_MESSAGE_DELETE, RESET_UNREAD_COUNT, UPDATE_MUTE_RECENT_CHAT, CLEAR_ALL_CHAT, UNREAD_USER_OBJ } from '../Actions/Constants';

const initialState = {
    id: null,
    activeUser: {},
    unreadDataObj: {},
};
const initialUnreadUserObj = {};

// The badge value is whatever the UnreadManager engine computes — the reducer is
// a dumb setter. localStorage mirrors the message-total so it can never drift
// from the sum of the per-chat counts.
const persistTotal = unreadDataObj => {
    const total = Object.values(unreadDataObj).reduce((sum, item) => sum + (item?.count || 0), 0);
    localStorage.setItem('unreadMessageCount', total);
};

const setCount = (unreadDataObj, currentData) => {
    const next = { ...unreadDataObj };
    const count = parseInt(currentData.count);
    const value = Number.isNaN(count) ? next[currentData.fromUserId]?.count || 0 : count;
    next[currentData.fromUserId] = { count: value };
    persistTotal(next);
    return next;
};

const deleteCount = (unreadDataObj, currentData) => {
    if (!unreadDataObj[currentData.fromUserId]) return unreadDataObj;
    const next = { ...unreadDataObj };
    delete next[currentData.fromUserId];
    persistTotal(next);
    return next;
};

export function UnreadCountReducer(state = { ...initialState }, action = {}) {
    const { payload } = action;
    switch (action.type) {
        case UNREAD_MESSAGE_UPDATE:
            return {
                ...state,
                id: payload.id,
                unreadDataObj: setCount(state.unreadDataObj, payload.data),
            };
        case UNREAD_MESSAGE_DELETE:
            return {
                ...state,
                id: payload.id,
                activeUser: payload.data,
                unreadDataObj: deleteCount(state.unreadDataObj, payload.data),
            };
        case RESET_UNREAD_COUNT:
            localStorage.setItem('unreadMessageCount', 0);
            return {
                id: null,
                activeUser: {},
                unreadDataObj: {},
            };
        case UPDATE_MUTE_RECENT_CHAT:
            return {
                ...state,
            };
        case CLEAR_ALL_CHAT:
            localStorage.setItem('unreadMessageCount', 0);
            return {
                ...state,
                id: payload.fromUserId,
                unreadDataObj: {},
            };
        default:
            return state;
    }
}

// Lean per-chat record. `count` mirrors the canonical badge value (BrowserTitle
// and RecentChatItem read it as a fallback); the rest is the open-session
// metadata the conversation needs to place the "N unread messages" bar.
export function UnreadUserObjReducer(state = { ...initialUnreadUserObj }, action = {}) {
    const { type, payload } = action;
    if (type === UNREAD_USER_OBJ) {
        const data = payload.data;
        const { fromUserId } = data;
        const prev = state[fromUserId] || {};
        return {
            ...state,
            [fromUserId]: {
                fromUserId,
                count: data.count ?? prev.count ?? 0,
                serverUnread: data.serverUnread ?? prev.serverUnread ?? 0,
                anchorUnread: data.anchorUnread ?? prev.anchorUnread ?? 0,
                anchorMsgId: data.anchorMsgId ?? prev.anchorMsgId ?? '',
                latestMsgId: data.latestMsgId ?? prev.latestMsgId ?? '',
                fetchLastMsgId: data.fetchLastMsgId ?? prev.fetchLastMsgId ?? '',
                chatJid: data.chatJid || prev.chatJid || '',
                groupId: data.groupId ?? prev.groupId ?? '',
            },
        };
    }
    return state;
}
